/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminStockAdjustLocationAddBoxReqVo,
  AdminStockAdjustLocationAssignReqVo,
  AdminStockAdjustLocationBoxDimensionReqVo,
  AdminStockAdjustLocationMoveReqVo,
  AdminStockAdjustReqVo,
  AdminStorageFeeRetryReqVo,
  ResponseAdminStockAdjustInitResVo,
  ResponseAdminStockAdjustLocationAddBoxResVo,
  ResponseAdminStockAdjustLocationAssignResVo,
  ResponseAdminStockAdjustLocationBoxDimensionResVo,
  ResponseAdminStockAdjustLocationDetailResVo,
  ResponseAdminStockAdjustLocationMoveInitResVo,
  ResponseAdminStockAdjustLocationMoveResVo,
  ResponseAdminStockAdjustLocationOptionsResVo,
  ResponseAdminStockAdjustResVo,
  ResponseAdminStockManageSummaryResVo,
  ResponseAdminStockManageUserSummaryResVo,
  ResponseBoolean,
  ResponseListStockAdjustDetailResVo,
  ResponseListStockDetailExportDto,
  ResponseListStockInboundDetailExportDto,
  ResponseListStockInboundDetailResVo,
  ResponseListStockOutboundDetailExportDto,
  ResponseListStockOutboundDetailResVo,
  ResponseListStockStorageFeeListResVo,
  ResponseListStorageFeeRetryResultDto,
  ResponsePageDataAdminStockAdjustRecordListResVo,
  ResponsePageDataAdminStockDepletedListResVo,
  ResponsePageDataAdminStockManageListResVo,
  ResponsePageDataAdminStockManageUserListResVo,
  ResponsePageDataStockGoodsListResVo,
  ResponsePageDataStockManageListResVo,
  ResponseStockManageSummaryResVo,
} from '../models/index';
import {
    AdminStockAdjustLocationAddBoxReqVoFromJSON,
    AdminStockAdjustLocationAddBoxReqVoToJSON,
    AdminStockAdjustLocationAssignReqVoFromJSON,
    AdminStockAdjustLocationAssignReqVoToJSON,
    AdminStockAdjustLocationBoxDimensionReqVoFromJSON,
    AdminStockAdjustLocationBoxDimensionReqVoToJSON,
    AdminStockAdjustLocationMoveReqVoFromJSON,
    AdminStockAdjustLocationMoveReqVoToJSON,
    AdminStockAdjustReqVoFromJSON,
    AdminStockAdjustReqVoToJSON,
    AdminStorageFeeRetryReqVoFromJSON,
    AdminStorageFeeRetryReqVoToJSON,
    ResponseAdminStockAdjustInitResVoFromJSON,
    ResponseAdminStockAdjustInitResVoToJSON,
    ResponseAdminStockAdjustLocationAddBoxResVoFromJSON,
    ResponseAdminStockAdjustLocationAddBoxResVoToJSON,
    ResponseAdminStockAdjustLocationAssignResVoFromJSON,
    ResponseAdminStockAdjustLocationAssignResVoToJSON,
    ResponseAdminStockAdjustLocationBoxDimensionResVoFromJSON,
    ResponseAdminStockAdjustLocationBoxDimensionResVoToJSON,
    ResponseAdminStockAdjustLocationDetailResVoFromJSON,
    ResponseAdminStockAdjustLocationDetailResVoToJSON,
    ResponseAdminStockAdjustLocationMoveInitResVoFromJSON,
    ResponseAdminStockAdjustLocationMoveInitResVoToJSON,
    ResponseAdminStockAdjustLocationMoveResVoFromJSON,
    ResponseAdminStockAdjustLocationMoveResVoToJSON,
    ResponseAdminStockAdjustLocationOptionsResVoFromJSON,
    ResponseAdminStockAdjustLocationOptionsResVoToJSON,
    ResponseAdminStockAdjustResVoFromJSON,
    ResponseAdminStockAdjustResVoToJSON,
    ResponseAdminStockManageSummaryResVoFromJSON,
    ResponseAdminStockManageSummaryResVoToJSON,
    ResponseAdminStockManageUserSummaryResVoFromJSON,
    ResponseAdminStockManageUserSummaryResVoToJSON,
    ResponseBooleanFromJSON,
    ResponseBooleanToJSON,
    ResponseListStockAdjustDetailResVoFromJSON,
    ResponseListStockAdjustDetailResVoToJSON,
    ResponseListStockDetailExportDtoFromJSON,
    ResponseListStockDetailExportDtoToJSON,
    ResponseListStockInboundDetailExportDtoFromJSON,
    ResponseListStockInboundDetailExportDtoToJSON,
    ResponseListStockInboundDetailResVoFromJSON,
    ResponseListStockInboundDetailResVoToJSON,
    ResponseListStockOutboundDetailExportDtoFromJSON,
    ResponseListStockOutboundDetailExportDtoToJSON,
    ResponseListStockOutboundDetailResVoFromJSON,
    ResponseListStockOutboundDetailResVoToJSON,
    ResponseListStockStorageFeeListResVoFromJSON,
    ResponseListStockStorageFeeListResVoToJSON,
    ResponseListStorageFeeRetryResultDtoFromJSON,
    ResponseListStorageFeeRetryResultDtoToJSON,
    ResponsePageDataAdminStockAdjustRecordListResVoFromJSON,
    ResponsePageDataAdminStockAdjustRecordListResVoToJSON,
    ResponsePageDataAdminStockDepletedListResVoFromJSON,
    ResponsePageDataAdminStockDepletedListResVoToJSON,
    ResponsePageDataAdminStockManageListResVoFromJSON,
    ResponsePageDataAdminStockManageListResVoToJSON,
    ResponsePageDataAdminStockManageUserListResVoFromJSON,
    ResponsePageDataAdminStockManageUserListResVoToJSON,
    ResponsePageDataStockGoodsListResVoFromJSON,
    ResponsePageDataStockGoodsListResVoToJSON,
    ResponsePageDataStockManageListResVoFromJSON,
    ResponsePageDataStockManageListResVoToJSON,
    ResponseStockManageSummaryResVoFromJSON,
    ResponseStockManageSummaryResVoToJSON,
} from '../models/index';

export interface StockAvailableGoodsGetRequest {
    nationId: number;
    currentPage?: number;
    pageSize?: number;
    userId?: number;
    warehouseId?: number;
    keyword?: string;
    businessPlatformId?: number;
}

export interface StockDetailsExportGetRequest {
    userId: number;
    warehouseId: number;
    spuCode?: string;
    skuCode?: string;
    marketBarcode?: string;
    marketOptionId?: string;
    spuIds?: Array<number>;
    skuIds?: Array<number>;
}

export interface StockDetailsPreviewGetRequest {
    userId: number;
    warehouseId: number;
    spuCode?: string;
    skuCode?: string;
    marketBarcode?: string;
    marketOptionId?: string;
    spuIds?: Array<number>;
    skuIds?: Array<number>;
}

export interface StockInOutDetailsAdjustGetRequest {
    userId: number;
    skuCode: string;
    nationId?: number;
    warehouseId?: number;
}

export interface StockInOutDetailsInboundExportGetRequest {
    userId: number;
    warehouseId: number;
    spuCode?: string;
    skuCode?: string;
    marketBarcode?: string;
    marketOptionId?: string;
    spuIds?: Array<number>;
    skuIds?: Array<number>;
    orderCode?: string;
    startTime?: string;
    endTime?: string;
}

export interface StockInOutDetailsInboundGetRequest {
    userId: number;
    skuCode: string;
    nationId?: number;
    warehouseId?: number;
}

export interface StockInOutDetailsInboundPreviewGetRequest {
    userId: number;
    warehouseId: number;
    spuCode?: string;
    skuCode?: string;
    marketBarcode?: string;
    marketOptionId?: string;
    spuIds?: Array<number>;
    skuIds?: Array<number>;
    orderCode?: string;
    startTime?: string;
    endTime?: string;
}

export interface StockInOutDetailsOutboundExportGetRequest {
    userId: number;
    warehouseId: number;
    spuCode?: string;
    skuCode?: string;
    marketBarcode?: string;
    marketOptionId?: string;
    spuIds?: Array<number>;
    skuIds?: Array<number>;
    orderCode?: string;
    startTime?: string;
    endTime?: string;
}

export interface StockInOutDetailsOutboundGetRequest {
    userId: number;
    skuCode: string;
    nationId?: number;
    warehouseId?: number;
}

export interface StockInOutDetailsOutboundPreviewGetRequest {
    userId: number;
    warehouseId: number;
    spuCode?: string;
    skuCode?: string;
    marketBarcode?: string;
    marketOptionId?: string;
    spuIds?: Array<number>;
    skuIds?: Array<number>;
    orderCode?: string;
    startTime?: string;
    endTime?: string;
}

export interface StockLocationAdjustmentsAssignmentsPostRequest {
    adminStockAdjustLocationAssignReqVo?: AdminStockAdjustLocationAssignReqVo;
}

export interface StockLocationAdjustmentsBoxDimensionsPostRequest {
    adminStockAdjustLocationBoxDimensionReqVo?: AdminStockAdjustLocationBoxDimensionReqVo;
}

export interface StockLocationAdjustmentsBoxesPostRequest {
    adminStockAdjustLocationAddBoxReqVo?: AdminStockAdjustLocationAddBoxReqVo;
}

export interface StockLocationAdjustmentsGetRequest {
    userId: number;
    warehouseId: number;
    nationId?: number;
    batch?: string;
    markNo?: string;
    skuId?: string;
}

export interface StockLocationAdjustmentsLocationOptionsGetRequest {
    userId: number;
    warehouseId: number;
}

export interface StockLocationAdjustmentsMovesInitGetRequest {
    userId: number;
    warehouseId: number;
    sourceBoxId: number;
    goodsId: number;
    skuId: number;
}

export interface StockLocationAdjustmentsMovesPostRequest {
    adminStockAdjustLocationMoveReqVo?: AdminStockAdjustLocationMoveReqVo;
}

export interface StockManageListGetRequest {
    userId: number;
    nationId: number;
    currentPage?: number;
    pageSize?: number;
    spuCode?: string;
    skuCode?: string;
    marketBarcode?: string;
    marketOptionId?: string;
}

export interface StockManageSummaryGetRequest {
    userId: number;
    nationId: number;
}

export interface StockMembersGetRequest {
    warehouseId: number;
    currentPage?: number;
    pageSize?: number;
    userName?: string;
    userCode?: string;
    skuId?: string;
}

export interface StockMembersSkusGetRequest {
    userId: number;
    warehouseId: number;
    currentPage?: number;
    pageSize?: number;
    nationId?: number;
    skuId?: string;
    productName?: string;
    markNo?: string;
}

export interface StockMembersSummaryGetRequest {
    userId: number;
    warehouseId: number;
    nationId?: number;
}

export interface StockSkuAdjustmentsInitGetRequest {
    userId: number;
    warehouseId: number;
    skuId: number;
    nationId?: number;
}

export interface StockSkuAdjustmentsPostRequest {
    adminStockAdjustReqVo?: AdminStockAdjustReqVo;
}

export interface StockSkuAdjustmentsRecordsGetRequest {
    warehouseId: number;
    currentPage?: number;
    pageSize?: number;
    userId?: number;
    skuId?: string;
    userName?: string;
    userCode?: string;
}

export interface StockSkusDepletedGetRequest {
    warehouseId: number;
    currentPage?: number;
    pageSize?: number;
    nationId?: number;
    userId?: number;
    skuId?: string;
    userName?: string;
    userCode?: string;
    productName?: string;
}

export interface StockStorageFeesExportGetRequest {
    userId: number;
    startDate: string;
    endDate: string;
    nationId?: number;
    warehouseId?: number;
}

export interface StockStorageFeesGetRequest {
    userId: number;
    startDate: string;
    endDate: string;
    nationId?: number;
    warehouseId?: number;
}

export interface StockStorageFeesRetryPostRequest {
    adminStorageFeeRetryReqVo?: AdminStorageFeeRetryReqVo;
}

export interface StockSummariesGetRequest {
    warehouseId: number;
    nationId?: number;
}

/**
 * 
 */
export class StockControllerApi extends runtime.BaseAPI {

    /**
     * 客户端·库存下单·可用库存列表
     * 客户端·库存下单·可用库存列表
     */
    async stockAvailableGoodsGetRaw(requestParameters: StockAvailableGoodsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataStockGoodsListResVo>> {
        if (requestParameters['nationId'] == null) {
            throw new runtime.RequiredError(
                'nationId',
                'Required parameter "nationId" was null or undefined when calling stockAvailableGoodsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['nationId'] != null) {
            queryParameters['nationId'] = requestParameters['nationId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['keyword'] != null) {
            queryParameters['keyword'] = requestParameters['keyword'];
        }

        if (requestParameters['businessPlatformId'] != null) {
            queryParameters['businessPlatformId'] = requestParameters['businessPlatformId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/available-goods`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataStockGoodsListResVoFromJSON(jsonValue));
    }

    /**
     * 客户端·库存下单·可用库存列表
     * 客户端·库存下单·可用库存列表
     */
    async stockAvailableGoodsGet(requestParameters: StockAvailableGoodsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataStockGoodsListResVo> {
        const response = await this.stockAvailableGoodsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端·库存明细导出
     * 客户端·库存明细导出
     */
    async stockDetailsExportGetRaw(requestParameters: StockDetailsExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling stockDetailsExportGet().'
            );
        }

        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling stockDetailsExportGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['spuCode'] != null) {
            queryParameters['spuCode'] = requestParameters['spuCode'];
        }

        if (requestParameters['skuCode'] != null) {
            queryParameters['skuCode'] = requestParameters['skuCode'];
        }

        if (requestParameters['marketBarcode'] != null) {
            queryParameters['marketBarcode'] = requestParameters['marketBarcode'];
        }

        if (requestParameters['marketOptionId'] != null) {
            queryParameters['marketOptionId'] = requestParameters['marketOptionId'];
        }

        if (requestParameters['spuIds'] != null) {
            queryParameters['spuIds'] = requestParameters['spuIds'];
        }

        if (requestParameters['skuIds'] != null) {
            queryParameters['skuIds'] = requestParameters['skuIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/details/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 客户端·库存明细导出
     * 客户端·库存明细导出
     */
    async stockDetailsExportGet(requestParameters: StockDetailsExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.stockDetailsExportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端·库存明细预览
     * 客户端·库存明细预览
     */
    async stockDetailsPreviewGetRaw(requestParameters: StockDetailsPreviewGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListStockDetailExportDto>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling stockDetailsPreviewGet().'
            );
        }

        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling stockDetailsPreviewGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['spuCode'] != null) {
            queryParameters['spuCode'] = requestParameters['spuCode'];
        }

        if (requestParameters['skuCode'] != null) {
            queryParameters['skuCode'] = requestParameters['skuCode'];
        }

        if (requestParameters['marketBarcode'] != null) {
            queryParameters['marketBarcode'] = requestParameters['marketBarcode'];
        }

        if (requestParameters['marketOptionId'] != null) {
            queryParameters['marketOptionId'] = requestParameters['marketOptionId'];
        }

        if (requestParameters['spuIds'] != null) {
            queryParameters['spuIds'] = requestParameters['spuIds'];
        }

        if (requestParameters['skuIds'] != null) {
            queryParameters['skuIds'] = requestParameters['skuIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/details/preview`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListStockDetailExportDtoFromJSON(jsonValue));
    }

    /**
     * 客户端·库存明细预览
     * 客户端·库存明细预览
     */
    async stockDetailsPreviewGet(requestParameters: StockDetailsPreviewGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListStockDetailExportDto> {
        const response = await this.stockDetailsPreviewGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 库存管理·SKU调整明细(不分页)
     * 库存管理·SKU调整明细(不分页)
     */
    async stockInOutDetailsAdjustGetRaw(requestParameters: StockInOutDetailsAdjustGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListStockAdjustDetailResVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling stockInOutDetailsAdjustGet().'
            );
        }

        if (requestParameters['skuCode'] == null) {
            throw new runtime.RequiredError(
                'skuCode',
                'Required parameter "skuCode" was null or undefined when calling stockInOutDetailsAdjustGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['skuCode'] != null) {
            queryParameters['skuCode'] = requestParameters['skuCode'];
        }

        if (requestParameters['nationId'] != null) {
            queryParameters['nationId'] = requestParameters['nationId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/in-out-details/adjust`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListStockAdjustDetailResVoFromJSON(jsonValue));
    }

    /**
     * 库存管理·SKU调整明细(不分页)
     * 库存管理·SKU调整明细(不分页)
     */
    async stockInOutDetailsAdjustGet(requestParameters: StockInOutDetailsAdjustGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListStockAdjustDetailResVo> {
        const response = await this.stockInOutDetailsAdjustGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端·库存入库明细导出
     * 客户端·库存入库明细导出
     */
    async stockInOutDetailsInboundExportGetRaw(requestParameters: StockInOutDetailsInboundExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling stockInOutDetailsInboundExportGet().'
            );
        }

        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling stockInOutDetailsInboundExportGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['spuCode'] != null) {
            queryParameters['spuCode'] = requestParameters['spuCode'];
        }

        if (requestParameters['skuCode'] != null) {
            queryParameters['skuCode'] = requestParameters['skuCode'];
        }

        if (requestParameters['marketBarcode'] != null) {
            queryParameters['marketBarcode'] = requestParameters['marketBarcode'];
        }

        if (requestParameters['marketOptionId'] != null) {
            queryParameters['marketOptionId'] = requestParameters['marketOptionId'];
        }

        if (requestParameters['spuIds'] != null) {
            queryParameters['spuIds'] = requestParameters['spuIds'];
        }

        if (requestParameters['skuIds'] != null) {
            queryParameters['skuIds'] = requestParameters['skuIds'];
        }

        if (requestParameters['orderCode'] != null) {
            queryParameters['orderCode'] = requestParameters['orderCode'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/in-out-details/inbound/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 客户端·库存入库明细导出
     * 客户端·库存入库明细导出
     */
    async stockInOutDetailsInboundExportGet(requestParameters: StockInOutDetailsInboundExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.stockInOutDetailsInboundExportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端·SKU入库明细
     * 客户端·SKU入库明细
     */
    async stockInOutDetailsInboundGetRaw(requestParameters: StockInOutDetailsInboundGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListStockInboundDetailResVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling stockInOutDetailsInboundGet().'
            );
        }

        if (requestParameters['skuCode'] == null) {
            throw new runtime.RequiredError(
                'skuCode',
                'Required parameter "skuCode" was null or undefined when calling stockInOutDetailsInboundGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['skuCode'] != null) {
            queryParameters['skuCode'] = requestParameters['skuCode'];
        }

        if (requestParameters['nationId'] != null) {
            queryParameters['nationId'] = requestParameters['nationId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/in-out-details/inbound`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListStockInboundDetailResVoFromJSON(jsonValue));
    }

    /**
     * 客户端·SKU入库明细
     * 客户端·SKU入库明细
     */
    async stockInOutDetailsInboundGet(requestParameters: StockInOutDetailsInboundGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListStockInboundDetailResVo> {
        const response = await this.stockInOutDetailsInboundGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端·库存入库明细预览
     * 客户端·库存入库明细预览
     */
    async stockInOutDetailsInboundPreviewGetRaw(requestParameters: StockInOutDetailsInboundPreviewGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListStockInboundDetailExportDto>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling stockInOutDetailsInboundPreviewGet().'
            );
        }

        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling stockInOutDetailsInboundPreviewGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['spuCode'] != null) {
            queryParameters['spuCode'] = requestParameters['spuCode'];
        }

        if (requestParameters['skuCode'] != null) {
            queryParameters['skuCode'] = requestParameters['skuCode'];
        }

        if (requestParameters['marketBarcode'] != null) {
            queryParameters['marketBarcode'] = requestParameters['marketBarcode'];
        }

        if (requestParameters['marketOptionId'] != null) {
            queryParameters['marketOptionId'] = requestParameters['marketOptionId'];
        }

        if (requestParameters['spuIds'] != null) {
            queryParameters['spuIds'] = requestParameters['spuIds'];
        }

        if (requestParameters['skuIds'] != null) {
            queryParameters['skuIds'] = requestParameters['skuIds'];
        }

        if (requestParameters['orderCode'] != null) {
            queryParameters['orderCode'] = requestParameters['orderCode'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/in-out-details/inbound/preview`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListStockInboundDetailExportDtoFromJSON(jsonValue));
    }

    /**
     * 客户端·库存入库明细预览
     * 客户端·库存入库明细预览
     */
    async stockInOutDetailsInboundPreviewGet(requestParameters: StockInOutDetailsInboundPreviewGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListStockInboundDetailExportDto> {
        const response = await this.stockInOutDetailsInboundPreviewGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端·库存出库明细导出
     * 客户端·库存出库明细导出
     */
    async stockInOutDetailsOutboundExportGetRaw(requestParameters: StockInOutDetailsOutboundExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling stockInOutDetailsOutboundExportGet().'
            );
        }

        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling stockInOutDetailsOutboundExportGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['spuCode'] != null) {
            queryParameters['spuCode'] = requestParameters['spuCode'];
        }

        if (requestParameters['skuCode'] != null) {
            queryParameters['skuCode'] = requestParameters['skuCode'];
        }

        if (requestParameters['marketBarcode'] != null) {
            queryParameters['marketBarcode'] = requestParameters['marketBarcode'];
        }

        if (requestParameters['marketOptionId'] != null) {
            queryParameters['marketOptionId'] = requestParameters['marketOptionId'];
        }

        if (requestParameters['spuIds'] != null) {
            queryParameters['spuIds'] = requestParameters['spuIds'];
        }

        if (requestParameters['skuIds'] != null) {
            queryParameters['skuIds'] = requestParameters['skuIds'];
        }

        if (requestParameters['orderCode'] != null) {
            queryParameters['orderCode'] = requestParameters['orderCode'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/in-out-details/outbound/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 客户端·库存出库明细导出
     * 客户端·库存出库明细导出
     */
    async stockInOutDetailsOutboundExportGet(requestParameters: StockInOutDetailsOutboundExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.stockInOutDetailsOutboundExportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端·SKU出库明细
     * 客户端·SKU出库明细
     */
    async stockInOutDetailsOutboundGetRaw(requestParameters: StockInOutDetailsOutboundGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListStockOutboundDetailResVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling stockInOutDetailsOutboundGet().'
            );
        }

        if (requestParameters['skuCode'] == null) {
            throw new runtime.RequiredError(
                'skuCode',
                'Required parameter "skuCode" was null or undefined when calling stockInOutDetailsOutboundGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['skuCode'] != null) {
            queryParameters['skuCode'] = requestParameters['skuCode'];
        }

        if (requestParameters['nationId'] != null) {
            queryParameters['nationId'] = requestParameters['nationId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/in-out-details/outbound`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListStockOutboundDetailResVoFromJSON(jsonValue));
    }

    /**
     * 客户端·SKU出库明细
     * 客户端·SKU出库明细
     */
    async stockInOutDetailsOutboundGet(requestParameters: StockInOutDetailsOutboundGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListStockOutboundDetailResVo> {
        const response = await this.stockInOutDetailsOutboundGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端·库存出库明细预览
     * 客户端·库存出库明细预览
     */
    async stockInOutDetailsOutboundPreviewGetRaw(requestParameters: StockInOutDetailsOutboundPreviewGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListStockOutboundDetailExportDto>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling stockInOutDetailsOutboundPreviewGet().'
            );
        }

        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling stockInOutDetailsOutboundPreviewGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['spuCode'] != null) {
            queryParameters['spuCode'] = requestParameters['spuCode'];
        }

        if (requestParameters['skuCode'] != null) {
            queryParameters['skuCode'] = requestParameters['skuCode'];
        }

        if (requestParameters['marketBarcode'] != null) {
            queryParameters['marketBarcode'] = requestParameters['marketBarcode'];
        }

        if (requestParameters['marketOptionId'] != null) {
            queryParameters['marketOptionId'] = requestParameters['marketOptionId'];
        }

        if (requestParameters['spuIds'] != null) {
            queryParameters['spuIds'] = requestParameters['spuIds'];
        }

        if (requestParameters['skuIds'] != null) {
            queryParameters['skuIds'] = requestParameters['skuIds'];
        }

        if (requestParameters['orderCode'] != null) {
            queryParameters['orderCode'] = requestParameters['orderCode'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/in-out-details/outbound/preview`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListStockOutboundDetailExportDtoFromJSON(jsonValue));
    }

    /**
     * 客户端·库存出库明细预览
     * 客户端·库存出库明细预览
     */
    async stockInOutDetailsOutboundPreviewGet(requestParameters: StockInOutDetailsOutboundPreviewGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListStockOutboundDetailExportDto> {
        const response = await this.stockInOutDetailsOutboundPreviewGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 管理端·库存管理·调整库位·批量指定货位
     * 管理端·库存管理·调整库位·批量指定货位
     */
    async stockLocationAdjustmentsAssignmentsPostRaw(requestParameters: StockLocationAdjustmentsAssignmentsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseAdminStockAdjustLocationAssignResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/location-adjustments/assignments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminStockAdjustLocationAssignReqVoToJSON(requestParameters['adminStockAdjustLocationAssignReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseAdminStockAdjustLocationAssignResVoFromJSON(jsonValue));
    }

    /**
     * 管理端·库存管理·调整库位·批量指定货位
     * 管理端·库存管理·调整库位·批量指定货位
     */
    async stockLocationAdjustmentsAssignmentsPost(requestParameters: StockLocationAdjustmentsAssignmentsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseAdminStockAdjustLocationAssignResVo> {
        const response = await this.stockLocationAdjustmentsAssignmentsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 管理端·库存管理·调整库位·修改箱尺寸
     * 管理端·库存管理·调整库位·修改箱尺寸
     */
    async stockLocationAdjustmentsBoxDimensionsPostRaw(requestParameters: StockLocationAdjustmentsBoxDimensionsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseAdminStockAdjustLocationBoxDimensionResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/location-adjustments/box-dimensions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminStockAdjustLocationBoxDimensionReqVoToJSON(requestParameters['adminStockAdjustLocationBoxDimensionReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseAdminStockAdjustLocationBoxDimensionResVoFromJSON(jsonValue));
    }

    /**
     * 管理端·库存管理·调整库位·修改箱尺寸
     * 管理端·库存管理·调整库位·修改箱尺寸
     */
    async stockLocationAdjustmentsBoxDimensionsPost(requestParameters: StockLocationAdjustmentsBoxDimensionsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseAdminStockAdjustLocationBoxDimensionResVo> {
        const response = await this.stockLocationAdjustmentsBoxDimensionsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 管理端·库存管理·调整库位·添加纸箱
     * 管理端·库存管理·调整库位·添加纸箱
     */
    async stockLocationAdjustmentsBoxesPostRaw(requestParameters: StockLocationAdjustmentsBoxesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseAdminStockAdjustLocationAddBoxResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/location-adjustments/boxes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminStockAdjustLocationAddBoxReqVoToJSON(requestParameters['adminStockAdjustLocationAddBoxReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseAdminStockAdjustLocationAddBoxResVoFromJSON(jsonValue));
    }

    /**
     * 管理端·库存管理·调整库位·添加纸箱
     * 管理端·库存管理·调整库位·添加纸箱
     */
    async stockLocationAdjustmentsBoxesPost(requestParameters: StockLocationAdjustmentsBoxesPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseAdminStockAdjustLocationAddBoxResVo> {
        const response = await this.stockLocationAdjustmentsBoxesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 管理端·库存管理·调整库位详情
     * 管理端·库存管理·调整库位详情
     */
    async stockLocationAdjustmentsGetRaw(requestParameters: StockLocationAdjustmentsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseAdminStockAdjustLocationDetailResVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling stockLocationAdjustmentsGet().'
            );
        }

        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling stockLocationAdjustmentsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['nationId'] != null) {
            queryParameters['nationId'] = requestParameters['nationId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['batch'] != null) {
            queryParameters['batch'] = requestParameters['batch'];
        }

        if (requestParameters['markNo'] != null) {
            queryParameters['markNo'] = requestParameters['markNo'];
        }

        if (requestParameters['skuId'] != null) {
            queryParameters['skuId'] = requestParameters['skuId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/location-adjustments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseAdminStockAdjustLocationDetailResVoFromJSON(jsonValue));
    }

    /**
     * 管理端·库存管理·调整库位详情
     * 管理端·库存管理·调整库位详情
     */
    async stockLocationAdjustmentsGet(requestParameters: StockLocationAdjustmentsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseAdminStockAdjustLocationDetailResVo> {
        const response = await this.stockLocationAdjustmentsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 管理端·库存管理·调整库位·可用货位下拉
     * 管理端·库存管理·调整库位·可用货位下拉
     */
    async stockLocationAdjustmentsLocationOptionsGetRaw(requestParameters: StockLocationAdjustmentsLocationOptionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseAdminStockAdjustLocationOptionsResVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling stockLocationAdjustmentsLocationOptionsGet().'
            );
        }

        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling stockLocationAdjustmentsLocationOptionsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/location-adjustments/location-options`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseAdminStockAdjustLocationOptionsResVoFromJSON(jsonValue));
    }

    /**
     * 管理端·库存管理·调整库位·可用货位下拉
     * 管理端·库存管理·调整库位·可用货位下拉
     */
    async stockLocationAdjustmentsLocationOptionsGet(requestParameters: StockLocationAdjustmentsLocationOptionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseAdminStockAdjustLocationOptionsResVo> {
        const response = await this.stockLocationAdjustmentsLocationOptionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 管理端·库存管理·调整库位·移箱初始化
     * 管理端·库存管理·调整库位·移箱初始化
     */
    async stockLocationAdjustmentsMovesInitGetRaw(requestParameters: StockLocationAdjustmentsMovesInitGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseAdminStockAdjustLocationMoveInitResVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling stockLocationAdjustmentsMovesInitGet().'
            );
        }

        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling stockLocationAdjustmentsMovesInitGet().'
            );
        }

        if (requestParameters['sourceBoxId'] == null) {
            throw new runtime.RequiredError(
                'sourceBoxId',
                'Required parameter "sourceBoxId" was null or undefined when calling stockLocationAdjustmentsMovesInitGet().'
            );
        }

        if (requestParameters['goodsId'] == null) {
            throw new runtime.RequiredError(
                'goodsId',
                'Required parameter "goodsId" was null or undefined when calling stockLocationAdjustmentsMovesInitGet().'
            );
        }

        if (requestParameters['skuId'] == null) {
            throw new runtime.RequiredError(
                'skuId',
                'Required parameter "skuId" was null or undefined when calling stockLocationAdjustmentsMovesInitGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['sourceBoxId'] != null) {
            queryParameters['sourceBoxId'] = requestParameters['sourceBoxId'];
        }

        if (requestParameters['goodsId'] != null) {
            queryParameters['goodsId'] = requestParameters['goodsId'];
        }

        if (requestParameters['skuId'] != null) {
            queryParameters['skuId'] = requestParameters['skuId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/location-adjustments/moves/init`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseAdminStockAdjustLocationMoveInitResVoFromJSON(jsonValue));
    }

    /**
     * 管理端·库存管理·调整库位·移箱初始化
     * 管理端·库存管理·调整库位·移箱初始化
     */
    async stockLocationAdjustmentsMovesInitGet(requestParameters: StockLocationAdjustmentsMovesInitGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseAdminStockAdjustLocationMoveInitResVo> {
        const response = await this.stockLocationAdjustmentsMovesInitGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 管理端·库存管理·调整库位·移箱提交
     * 管理端·库存管理·调整库位·移箱提交
     */
    async stockLocationAdjustmentsMovesPostRaw(requestParameters: StockLocationAdjustmentsMovesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseAdminStockAdjustLocationMoveResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/location-adjustments/moves`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminStockAdjustLocationMoveReqVoToJSON(requestParameters['adminStockAdjustLocationMoveReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseAdminStockAdjustLocationMoveResVoFromJSON(jsonValue));
    }

    /**
     * 管理端·库存管理·调整库位·移箱提交
     * 管理端·库存管理·调整库位·移箱提交
     */
    async stockLocationAdjustmentsMovesPost(requestParameters: StockLocationAdjustmentsMovesPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseAdminStockAdjustLocationMoveResVo> {
        const response = await this.stockLocationAdjustmentsMovesPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端·库存管理·列表
     * 客户端·库存管理·列表
     */
    async stockManageListGetRaw(requestParameters: StockManageListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataStockManageListResVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling stockManageListGet().'
            );
        }

        if (requestParameters['nationId'] == null) {
            throw new runtime.RequiredError(
                'nationId',
                'Required parameter "nationId" was null or undefined when calling stockManageListGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['nationId'] != null) {
            queryParameters['nationId'] = requestParameters['nationId'];
        }

        if (requestParameters['spuCode'] != null) {
            queryParameters['spuCode'] = requestParameters['spuCode'];
        }

        if (requestParameters['skuCode'] != null) {
            queryParameters['skuCode'] = requestParameters['skuCode'];
        }

        if (requestParameters['marketBarcode'] != null) {
            queryParameters['marketBarcode'] = requestParameters['marketBarcode'];
        }

        if (requestParameters['marketOptionId'] != null) {
            queryParameters['marketOptionId'] = requestParameters['marketOptionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/manage/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataStockManageListResVoFromJSON(jsonValue));
    }

    /**
     * 客户端·库存管理·列表
     * 客户端·库存管理·列表
     */
    async stockManageListGet(requestParameters: StockManageListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataStockManageListResVo> {
        const response = await this.stockManageListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端·库存管理·统计栏
     * 客户端·库存管理·统计栏
     */
    async stockManageSummaryGetRaw(requestParameters: StockManageSummaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseStockManageSummaryResVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling stockManageSummaryGet().'
            );
        }

        if (requestParameters['nationId'] == null) {
            throw new runtime.RequiredError(
                'nationId',
                'Required parameter "nationId" was null or undefined when calling stockManageSummaryGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['nationId'] != null) {
            queryParameters['nationId'] = requestParameters['nationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/manage/summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStockManageSummaryResVoFromJSON(jsonValue));
    }

    /**
     * 客户端·库存管理·统计栏
     * 客户端·库存管理·统计栏
     */
    async stockManageSummaryGet(requestParameters: StockManageSummaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseStockManageSummaryResVo> {
        const response = await this.stockManageSummaryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 管理端·库存管理·会员列表
     * 管理端·库存管理·会员列表
     */
    async stockMembersGetRaw(requestParameters: StockMembersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataAdminStockManageListResVo>> {
        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling stockMembersGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['userName'] != null) {
            queryParameters['userName'] = requestParameters['userName'];
        }

        if (requestParameters['userCode'] != null) {
            queryParameters['userCode'] = requestParameters['userCode'];
        }

        if (requestParameters['skuId'] != null) {
            queryParameters['skuId'] = requestParameters['skuId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/members`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataAdminStockManageListResVoFromJSON(jsonValue));
    }

    /**
     * 管理端·库存管理·会员列表
     * 管理端·库存管理·会员列表
     */
    async stockMembersGet(requestParameters: StockMembersGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataAdminStockManageListResVo> {
        const response = await this.stockMembersGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 管理端·库存管理·会员SKU列表
     * 管理端·库存管理·会员SKU列表
     */
    async stockMembersSkusGetRaw(requestParameters: StockMembersSkusGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataAdminStockManageUserListResVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling stockMembersSkusGet().'
            );
        }

        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling stockMembersSkusGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['nationId'] != null) {
            queryParameters['nationId'] = requestParameters['nationId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['skuId'] != null) {
            queryParameters['skuId'] = requestParameters['skuId'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['productName'] = requestParameters['productName'];
        }

        if (requestParameters['markNo'] != null) {
            queryParameters['markNo'] = requestParameters['markNo'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/members/skus`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataAdminStockManageUserListResVoFromJSON(jsonValue));
    }

    /**
     * 管理端·库存管理·会员SKU列表
     * 管理端·库存管理·会员SKU列表
     */
    async stockMembersSkusGet(requestParameters: StockMembersSkusGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataAdminStockManageUserListResVo> {
        const response = await this.stockMembersSkusGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 管理端·库存管理·会员统计栏
     * 管理端·库存管理·会员统计栏
     */
    async stockMembersSummaryGetRaw(requestParameters: StockMembersSummaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseAdminStockManageUserSummaryResVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling stockMembersSummaryGet().'
            );
        }

        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling stockMembersSummaryGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['nationId'] != null) {
            queryParameters['nationId'] = requestParameters['nationId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/members/summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseAdminStockManageUserSummaryResVoFromJSON(jsonValue));
    }

    /**
     * 管理端·库存管理·会员统计栏
     * 管理端·库存管理·会员统计栏
     */
    async stockMembersSummaryGet(requestParameters: StockMembersSummaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseAdminStockManageUserSummaryResVo> {
        const response = await this.stockMembersSummaryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 管理端·库存管理·SKU数量调整初始化
     * 管理端·库存管理·SKU数量调整初始化
     */
    async stockSkuAdjustmentsInitGetRaw(requestParameters: StockSkuAdjustmentsInitGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseAdminStockAdjustInitResVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling stockSkuAdjustmentsInitGet().'
            );
        }

        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling stockSkuAdjustmentsInitGet().'
            );
        }

        if (requestParameters['skuId'] == null) {
            throw new runtime.RequiredError(
                'skuId',
                'Required parameter "skuId" was null or undefined when calling stockSkuAdjustmentsInitGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['nationId'] != null) {
            queryParameters['nationId'] = requestParameters['nationId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['skuId'] != null) {
            queryParameters['skuId'] = requestParameters['skuId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/sku-adjustments/init`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseAdminStockAdjustInitResVoFromJSON(jsonValue));
    }

    /**
     * 管理端·库存管理·SKU数量调整初始化
     * 管理端·库存管理·SKU数量调整初始化
     */
    async stockSkuAdjustmentsInitGet(requestParameters: StockSkuAdjustmentsInitGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseAdminStockAdjustInitResVo> {
        const response = await this.stockSkuAdjustmentsInitGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 管理端·库存管理·SKU数量调整提交
     * 管理端·库存管理·SKU数量调整提交
     */
    async stockSkuAdjustmentsPostRaw(requestParameters: StockSkuAdjustmentsPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseAdminStockAdjustResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/sku-adjustments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminStockAdjustReqVoToJSON(requestParameters['adminStockAdjustReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseAdminStockAdjustResVoFromJSON(jsonValue));
    }

    /**
     * 管理端·库存管理·SKU数量调整提交
     * 管理端·库存管理·SKU数量调整提交
     */
    async stockSkuAdjustmentsPost(requestParameters: StockSkuAdjustmentsPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseAdminStockAdjustResVo> {
        const response = await this.stockSkuAdjustmentsPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 仓库管理→库存管理：数量调整流水（Stock.vue），独立业务记录。 库存管理·数量调整流水
     * 库存管理·数量调整流水
     */
    async stockSkuAdjustmentsRecordsGetRaw(requestParameters: StockSkuAdjustmentsRecordsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataAdminStockAdjustRecordListResVo>> {
        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling stockSkuAdjustmentsRecordsGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['skuId'] != null) {
            queryParameters['skuId'] = requestParameters['skuId'];
        }

        if (requestParameters['userName'] != null) {
            queryParameters['userName'] = requestParameters['userName'];
        }

        if (requestParameters['userCode'] != null) {
            queryParameters['userCode'] = requestParameters['userCode'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/sku-adjustments/records`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataAdminStockAdjustRecordListResVoFromJSON(jsonValue));
    }

    /**
     * 仓库管理→库存管理：数量调整流水（Stock.vue），独立业务记录。 库存管理·数量调整流水
     * 库存管理·数量调整流水
     */
    async stockSkuAdjustmentsRecordsGet(requestParameters: StockSkuAdjustmentsRecordsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataAdminStockAdjustRecordListResVo> {
        const response = await this.stockSkuAdjustmentsRecordsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 管理端·库存管理·库存耗尽列表
     * 管理端·库存管理·库存耗尽列表
     */
    async stockSkusDepletedGetRaw(requestParameters: StockSkusDepletedGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataAdminStockDepletedListResVo>> {
        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling stockSkusDepletedGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['nationId'] != null) {
            queryParameters['nationId'] = requestParameters['nationId'];
        }

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['skuId'] != null) {
            queryParameters['skuId'] = requestParameters['skuId'];
        }

        if (requestParameters['userName'] != null) {
            queryParameters['userName'] = requestParameters['userName'];
        }

        if (requestParameters['userCode'] != null) {
            queryParameters['userCode'] = requestParameters['userCode'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['productName'] = requestParameters['productName'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/skus/depleted`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataAdminStockDepletedListResVoFromJSON(jsonValue));
    }

    /**
     * 管理端·库存管理·库存耗尽列表
     * 管理端·库存管理·库存耗尽列表
     */
    async stockSkusDepletedGet(requestParameters: StockSkusDepletedGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataAdminStockDepletedListResVo> {
        const response = await this.stockSkusDepletedGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端·保管费明细导出
     * 客户端·保管费明细导出
     */
    async stockStorageFeesExportGetRaw(requestParameters: StockStorageFeesExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseBoolean>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling stockStorageFeesExportGet().'
            );
        }

        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling stockStorageFeesExportGet().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling stockStorageFeesExportGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['nationId'] != null) {
            queryParameters['nationId'] = requestParameters['nationId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/storage-fees/export`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseBooleanFromJSON(jsonValue));
    }

    /**
     * 客户端·保管费明细导出
     * 客户端·保管费明细导出
     */
    async stockStorageFeesExportGet(requestParameters: StockStorageFeesExportGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseBoolean> {
        const response = await this.stockStorageFeesExportGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 客户端·保管费明细
     * 客户端·保管费明细
     */
    async stockStorageFeesGetRaw(requestParameters: StockStorageFeesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListStockStorageFeeListResVo>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling stockStorageFeesGet().'
            );
        }

        if (requestParameters['startDate'] == null) {
            throw new runtime.RequiredError(
                'startDate',
                'Required parameter "startDate" was null or undefined when calling stockStorageFeesGet().'
            );
        }

        if (requestParameters['endDate'] == null) {
            throw new runtime.RequiredError(
                'endDate',
                'Required parameter "endDate" was null or undefined when calling stockStorageFeesGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['userId'] = requestParameters['userId'];
        }

        if (requestParameters['nationId'] != null) {
            queryParameters['nationId'] = requestParameters['nationId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = requestParameters['startDate'];
        }

        if (requestParameters['endDate'] != null) {
            queryParameters['endDate'] = requestParameters['endDate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/storage-fees`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListStockStorageFeeListResVoFromJSON(jsonValue));
    }

    /**
     * 客户端·保管费明细
     * 客户端·保管费明细
     */
    async stockStorageFeesGet(requestParameters: StockStorageFeesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListStockStorageFeeListResVo> {
        const response = await this.stockStorageFeesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 管理端·按日期补跑保管费
     * 管理端·按日期补跑保管费
     */
    async stockStorageFeesRetryPostRaw(requestParameters: StockStorageFeesRetryPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListStorageFeeRetryResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/storage-fees/retry`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminStorageFeeRetryReqVoToJSON(requestParameters['adminStorageFeeRetryReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListStorageFeeRetryResultDtoFromJSON(jsonValue));
    }

    /**
     * 管理端·按日期补跑保管费
     * 管理端·按日期补跑保管费
     */
    async stockStorageFeesRetryPost(requestParameters: StockStorageFeesRetryPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListStorageFeeRetryResultDto> {
        const response = await this.stockStorageFeesRetryPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 管理端·库存管理·全局统计栏
     * 管理端·库存管理·全局统计栏
     */
    async stockSummariesGetRaw(requestParameters: StockSummariesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseAdminStockManageSummaryResVo>> {
        if (requestParameters['warehouseId'] == null) {
            throw new runtime.RequiredError(
                'warehouseId',
                'Required parameter "warehouseId" was null or undefined when calling stockSummariesGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['nationId'] != null) {
            queryParameters['nationId'] = requestParameters['nationId'];
        }

        if (requestParameters['warehouseId'] != null) {
            queryParameters['warehouseId'] = requestParameters['warehouseId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/stock/summaries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseAdminStockManageSummaryResVoFromJSON(jsonValue));
    }

    /**
     * 管理端·库存管理·全局统计栏
     * 管理端·库存管理·全局统计栏
     */
    async stockSummariesGet(requestParameters: StockSummariesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseAdminStockManageSummaryResVo> {
        const response = await this.stockSummariesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
